import { each, find } from 'lodash-es'

export default (query, { filters }) => {
  const selected = {}
  each(query, (value, key) => {
    const filter = find(filters, f => f.name === key)
    if (filter) {
      const { type } = filter
      if (type === 'text' || type === 'radio' || type === 'select') {
        selected[key] = value
      } else if (type === 'slider') {
        const vals = value.split(',')
        if (vals.length === 2) {
          const [min, max] = vals
          if (!isNaN(min) && !isNaN(max)) {
            selected[key] = [+min, +max]
          }
        }
      } else if (type === 'date') {
        const vals = value.split(',')
        if (vals.length === 2) {
          const [start, end] = vals
          const pattern = /^\d{4}-\d{2}-\d{2}$/
          if (pattern.test(start) && pattern.test(end)) {
            selected[key] = [start, end]
          }
        }
      } else if (type === 'checkbox' || type === 'multiselect') {
        const vals = value.split(',')
        if (vals.length) {
          selected[key] = vals
        }
      }
    }
  })

  return selected
}